import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { CaretLeft, GraduationCap, Translate, CalendarBlank, ArrowRight } from "@phosphor-icons/react";
import { getDoctor } from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function DoctorDetail() {
  const { id } = useParams();
  const [d, setD] = useState(null);
  useEffect(() => { getDoctor(id).then(setD).catch(() => {}); }, [id]);
  if (!d) return <div className="max-w-3xl mx-auto p-16 text-brand-muted">Loading…</div>;

  return (
    <div data-testid="doctor-detail-page">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-10">
        <Link to="/doctors" className="inline-flex items-center gap-2 text-sm text-brand-muted hover:text-brand-ink" data-testid="back-to-doctors">
          <CaretLeft size={16} /> All doctors
        </Link>
      </div>
      <section className="max-w-7xl mx-auto px-6 lg:px-10 pt-8 pb-20 grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5">
          <div className="aspect-[4/5] rounded-3xl overflow-hidden bg-[#E8ECE4] border border-brand-border">
            <img src={d.image} alt={d.name} className="w-full h-full object-cover" />
          </div>
        </div>
        <div className="lg:col-span-7">
          <div className="text-xs uppercase tracking-[0.28em] text-brand-sage mb-4">{d.specialty}</div>
          <h1 className="font-serif text-5xl sm:text-6xl tracking-tight leading-[1.02]">{d.name}</h1>
          <p className="mt-6 text-lg text-brand-muted leading-relaxed">{d.bio}</p>

          <div className="grid sm:grid-cols-2 gap-6 mt-10">
            <div className="rounded-2xl bg-white border border-brand-border p-6">
              <div className="flex items-center gap-2 text-brand-sage text-xs uppercase tracking-wider mb-3"><GraduationCap size={16} /> Qualifications</div>
              <ul className="space-y-1.5 text-sm text-brand-ink">
                {d.qualifications.map((q) => <li key={q}>{q}</li>)}
              </ul>
            </div>
            <div className="rounded-2xl bg-white border border-brand-border p-6">
              <div className="flex items-center gap-2 text-brand-sage text-xs uppercase tracking-wider mb-3"><Translate size={16} /> Languages</div>
              <div className="text-sm text-brand-ink">{d.languages.join(", ")}</div>
              <div className="flex items-center gap-2 text-brand-sage text-xs uppercase tracking-wider mt-5 mb-3"><CalendarBlank size={16} /> Consultation days</div>
              <div className="text-sm text-brand-ink">{d.consultation_days.join(", ")}</div>
            </div>
          </div>

          <div className="mt-10">
            <Link to="/book">
              <Button data-testid="doctor-book-btn" className="rounded-full bg-[#C85A40] hover:bg-[#A94A32] text-white h-13 px-7">
                Book with {d.name.split(" ")[1]} <ArrowRight size={18} className="ml-2" />
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
